// NO jQuery!
import debounce from 'lodash/debounce';

const banner = document.querySelector('[data-scroll-hide]');

if (banner) {
    const threshold = banner.offsetHeight;
    let lastWindowScrollPos = window.scrollY;

    const detectPageScroll = () => {
        const wScroll = window.scrollY;
        if (!banner.classList.contains('-scrolling')) {
            if (wScroll < 10) {
                banner.classList.remove('-hidden');
                banner.classList.add('-top', '-visible');
            } else if (wScroll < threshold) {
                banner.classList.remove('-hidden', '-top');
                banner.classList.add('-visible');
            } else if (wScroll > lastWindowScrollPos) {
                banner.classList.remove('-visible', '-top');
                banner.classList.add('-hidden');
            } else if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
                // do nothing, since we're at the bottom.
            } else if (wScroll < lastWindowScrollPos) {
                banner.classList.remove('-hidden', '-top');
                banner.classList.add('-visible');
            }
        }
        lastWindowScrollPos = wScroll;
    };

    detectPageScroll();

    // eslint-disable-next-line
    const debounceDetectPageScroll = debounce(detectPageScroll, 100, 'immediate');

    window.addEventListener('scroll', detectPageScroll);
    window.addEventListener('resize', detectPageScroll);
}
